import styled from 'styled-components';
import { Link, Icon } from 'components/common';
import { colours } from 'utils/theme';

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 14px;

  a {
    color: ${colours.blue};
    font-size: 14px;
  }
`;

const stripProtocolAndWww = url => url.replace(/^https?:\/\/(www\.)?/i, '');

const WebsiteLink = ({ websiteUrl }) => {
  if (!websiteUrl) {
    return null;
  }

  return (
    <Container>
      <div
        style={{
          minWidth: 15,
          width: 15,
          display: 'flex',
          justifyContent: 'center',
          marginRight: 5,
        }}
        data-testid='website-link-icon-container'
      >
        <Icon
          icon='globe'
          size='xs'
          color={colours.teal}
          data-testid='website-link-globe-icon'
        />
      </div>
      <Link external inline showIconHint to={websiteUrl}>
        {stripProtocolAndWww(websiteUrl)}
      </Link>
    </Container>
  );
};

export default WebsiteLink;
